import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const StackBarChart = ({
  labels = [],
  datasets = [],
  title = "",
  xStacked = true,
  yStacked = true,
  prefix = "",
  suffix = "",
  yAxisAsPercentage = false,
}) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: !!title,
        text: title,
      },
    },
    scales: {
      x: {
        stacked: xStacked,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: yStacked,
        min: yAxisAsPercentage ? 0 : undefined,
        max: yAxisAsPercentage ? 100 : undefined,
        ticks: {
          callback: (value) => {
            return prefix + value + (yAxisAsPercentage ? "%" : suffix);
          },
        },
      },
    },
  };

  const data = {
    labels,
    datasets: datasets.map((ds) => ({
      ...ds,
      barThickness: 30,
      borderRadius: 4,
    })),
  };

  return (
    <div className="w-full h-full">
      <Bar options={options} data={data} />
    </div>
  );
};

export default StackBarChart;